module.exports = __webpack_public_path__ + "media/images/ln/constellation_09-eda1038ca88021717ab4251a3c4bacb9.png";